import { Button } from "@marketplace/ui";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { MdOutlineTextSnippet } from "react-icons/md";

import { claimOrderSubmitModalAtom } from "../../atoms/claim-order-submit-modal-atom";
import type { ClaimOrderListItem } from "../../dtos/get-claim-order-list-response-dto";
import { useGetClaimHistoryDetailQuery } from "../../hooks/queries/use-get-claim-history-detail-query";

type ClaimResubmitButtonProps = {
  claimId: string;
};

export const ClaimResubmitButton = ({ claimId }: ClaimResubmitButtonProps) => {
  const { t } = useTranslation("order", {
    keyPrefix: "claimHistoryPage.table.columns"
  });
  const setSubmitModal = useSetAtom(claimOrderSubmitModalAtom);

  const { refetch, isFetching } = useGetClaimHistoryDetailQuery({
    queryParams: { claimId },
    options: { enabled: false }
  });

  const handleClick = async () => {
    const result = await refetch();
    const detail = result.data?.data;
    if (!detail) return;

    const orders: ClaimOrderListItem[] = detail.orders.map((o) => ({
      order_id: o.order_id,
      buyer_company_name: o.buyer_company_name,
      seller_company_name: o.seller_company_name,
      product_name: "",
      item_price: 0,
      created_at: detail.created_at,
      order_status: "",
      status_label: ""
    }));

    setSubmitModal({
      claimId: claimId,
      publicId: detail.public_id,
      visible: true,
      data: { orders },
      currentStatus: detail.current_status,
      prefill: {
        invoiceNumber: detail.invoice_number,
        invoiceAmount: detail.invoice_amount,
        taxInvoiceNumber: detail.tax_invoice_number,
        invoiceDate: detail.invoice_date,
        bankName: detail.bank_name,
        accountNumber: detail.account_number,
        accountName: detail.account_name,
        invoiceFilePath: detail.invoice_file_path,
        rejectReason: detail.reject_reason
      }
    });
  };

  return (
    <Button
      variant="primary"
      size="sm"
      rightSection={<MdOutlineTextSnippet size={14} />}
      loading={isFetching}
      onClick={handleClick}
    >
      {t("resubmit")}
    </Button>
  );
};
